export const isMaterialsKitEnabled = () => {
    const value = process.env.VUE_APP_FEATURE_FLAG_MATERIALS_KIT;
    const isEnabled = value === 'true';
    return isEnabled;
}